import { useTranslations } from 'next-intl';

export default function useATSName(): string {
  const t = useTranslations();
  return t(process.env.NEXT_PUBLIC_TITLE);
}
